import { AxiosMethods, QuotesV2Api } from '../../../../enums';
import { axiosHelper } from '../../../axios-instance';
import type {
  CreateQuoteV2SectionRequest,
  UpdateQuoteV2SectionRequest,
  DeleteQuoteV2SectionRequest
} from './types';

export * from './types';

export enum QuoteItemsV2MutationKey {
  CREATE_SECTION = 'create_quote_v2_section',
  UPDATE_SECTION = 'update_quote_v2_section',
  DELETE_SECTION = 'delete_quote_v2_section'
}

export const createQuoteV2SectionMutation = () => ({
  mutationKey: [QuoteItemsV2MutationKey.CREATE_SECTION],
  mutationFn: ({ quoteId, ...body }: CreateQuoteV2SectionRequest) =>
    axiosHelper({
      endpoint: QuotesV2Api.CreateSection.replace(':quoteId', quoteId),
      method: AxiosMethods.POST,
      baseURL: process.env.REVOPS_API,
      body
    })
});

export const updateQuoteV2SectionMutation = () => ({
  mutationKey: [QuoteItemsV2MutationKey.UPDATE_SECTION],
  mutationFn: ({ quoteId, sectionId, ...body }: UpdateQuoteV2SectionRequest) =>
    axiosHelper({
      endpoint: QuotesV2Api.UpdateSection.replace(':quoteId', quoteId).replace(
        ':sectionId',
        sectionId
      ),
      method: AxiosMethods.PATCH,
      baseURL: process.env.REVOPS_API,
      body
    })
});

export const deleteQuoteV2SectionMutation = () => ({
  mutationKey: [QuoteItemsV2MutationKey.DELETE_SECTION],
  mutationFn: ({
    quoteId,
    sectionId,
    keepItems = false
  }: DeleteQuoteV2SectionRequest) => {
    const base = QuotesV2Api.DeleteSection.replace(':quoteId', quoteId).replace(
      ':sectionId',
      sectionId
    );
    const endpoint = keepItems ? `${base}?keepItems=true` : base;

    return axiosHelper({
      endpoint,
      method: AxiosMethods.DELETE,
      baseURL: process.env.REVOPS_API
    });
  }
});
